export default __webpack_public_path__ + "static/media/rank3.ce59a48b.png";